import type { PostgresRole } from '@/shared/components/ProtectedRoute';
import type { CustomerRequestCategory, CustomerRequestStatus } from './types';

/** "Account Manager" is the sales_manager role (see shared/constants/roles.ts). */
export const CUSTOMER_REQUEST_VIEWER_ROLES: PostgresRole[] = ['sales_manager', 'csm', 'director', 'full_admin'];
export const CUSTOMER_REQUEST_STATUS_ROLES: PostgresRole[] = ['director', 'full_admin'];

export const STATUSES: { value: CustomerRequestStatus; label: string; className: string }[] = [
  { value: 'open', label: 'Open', className: 'bg-muted text-foreground' },
  { value: 'planned', label: 'Planned', className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200' },
  { value: 'in_progress', label: 'In progress', className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200' },
  { value: 'shipped', label: 'Shipped', className: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200' },
  { value: 'wont_do', label: "Won't do", className: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200' },
];

export const STATUS_LABEL = Object.fromEntries(STATUSES.map((s) => [s.value, s.label])) as Record<CustomerRequestStatus, string>;

export const CATEGORIES: { value: CustomerRequestCategory; label: string }[] = [
  { value: 'security', label: 'Security' },
  { value: 'reports', label: 'Reports' },
  { value: 'alerts', label: 'Alerts' },
  { value: 'integrations', label: 'Integrations' },
  { value: 'other', label: 'Other' },
];

export const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.value, c.label])) as Record<CustomerRequestCategory, string>;
